export default __webpack_public_path__ + "static/media/one.24cc8087.svg";